import React, { SVGProps } from 'react'
import dollarHistory from '../../assets/dollar-history.png'
import { ImageProps, Image } from '@chakra-ui/react'

export const RefillIcon = React.memo(({ color = '#fff' }: { color?: string }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.5" y="5" width="17" height="14" rx="2" stroke={color} strokeWidth="2" />
      <path
        d="M20.5 9H15.5C13.8431 9 12.5 10.3431 12.5 12V12C12.5 13.6569 13.8431 15 15.5 15H20.5"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="15.5" cy="12" r="1" fill={color} />
    </svg>
  )
})

export const TradeUrlIcon = React.memo((props?: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 13.874C3.27477 13.4299 2 11.8638 2 10C2 7.79086 3.79086 6 6 6H12C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14H11"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M13 10H12C9.79086 10 8 11.7909 8 14C8 16.2091 9.79086 18 12 18H18C20.2091 18 22 16.2091 22 14C22 12.1362 20.7252 10.5701 19 10.126"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  )
})

export const PromoCodeIcon = React.memo((props?: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C4 7.44772 4.44772 7 5 7H19C19.5523 7 20 7.44772 20 8V9.17071C18.8348 9.58254 18 10.6938 18 12C18 13.3062 18.8348 14.4175 20 14.8293V16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V14.8293C5.16519 14.4175 6 13.3062 6 12C6 10.6938 5.16519 9.58254 4 9.17071V8ZM5 5C3.34315 5 2 6.34315 2 8V10C2 10.5523 2.44772 11 3 11C3.55228 11 4 11.4477 4 12C4 12.5523 3.55228 13 3 13C2.44772 13 2 13.4477 2 14V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V14C22 13.4477 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 10.5523 22 10V8C22 6.34315 20.6569 5 19 5H5ZM9.5 11C10.3284 11 11 10.3284 11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11ZM14.2929 8.29289L8.29289 14.2929L9.70711 15.7071L15.7071 9.70711L14.2929 8.29289ZM16 14.5C16 15.3284 15.3284 16 14.5 16C13.6716 16 13 15.3284 13 14.5C13 13.6716 13.6716 13 14.5 13C15.3284 13 16 13.6716 16 14.5Z"
        fill="white"
      />
    </svg>
  )
})

export const DollarHistoryIcon = React.memo((props?: ImageProps) => {
  return (
    <Image
      src={dollarHistory}
      alt="dollar-history"
      width={['20px', '30px']}
      height={['20px', '30px']}
      {...props}
    />
  )
})

export const ShopIcon = React.memo(
  ({ color1 = '#514F63', color2 = '#8E8CA0' }: { color1?: string; color2?: string }) => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 21V14H8V21C8 22.1046 8.89543 23 10 23H20C21.1046 23 22 22.1046 22 21Z"
          stroke={color1}
          strokeWidth="2"
        />
        <path d="M15 14V23" stroke={color1} strokeWidth="2" strokeLinejoin="round" />
        <path
          d="M23 14V12C23 10.8954 22.1046 10 21 10H9C7.89543 10 7 10.8954 7 12V14H23Z"
          stroke={color2}
          strokeWidth="2"
        />
        <path d="M11 6L15 10L19 6" stroke={color2} strokeWidth="2" strokeLinejoin="round" />
      </svg>
    )
  },
)

export const PromoCodeIcon2 = React.memo(
  ({ color1 = '#514F63', color2 = '#8E8CA0' }: { color1?: string; color2?: string }) => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9V8H5V9H6ZM24 9H25V8H24V9ZM6 13H5V14H6V13ZM6 17V16H5V17H6ZM6 21H5V22H6V21ZM24 21V22H25V21H24ZM24 17H25V16H24V17ZM24 13V14H25V13H24ZM6 10H24V8H6V10ZM7 13V9H5V13H7ZM9 15C9 13.3431 7.65685 12 6 12V14C6.55228 14 7 14.4477 7 15H9ZM6 18C7.65685 18 9 16.6569 9 15H7C7 15.5523 6.55228 16 6 16V18ZM7 21V17H5V21H7ZM24 20H6V22H24V20ZM23 17V21H25V17H23ZM21 15C21 16.6569 22.3431 18 24 18V16C23.4477 16 23 15.5523 23 15H21ZM24 12C22.3431 12 21 13.3431 21 15H23C23 14.4477 23.4477 14 24 14V12ZM23 9V13H25V9H23Z"
          fill={color1}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 12.5C14 13.3284 13.3284 14 12.5 14C11.6716 14 11 13.3284 11 12.5C11 11.6716 11.6716 11 12.5 11C13.3284 11 14 11.6716 14 12.5ZM11.2929 17.2929L17.2929 11.2929L18.7071 12.7071L12.7071 18.7071L11.2929 17.2929ZM17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16C16.6716 16 16 16.6716 16 17.5C16 18.3284 16.6716 19 17.5 19Z"
          fill={color2}
        />
      </svg>
    )
  },
)

export const UpgradeIcon = React.memo(
  ({ color1 = '#514F63', color2 = '#8E8CA0' }: { color1?: string; color2?: string }) => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 6L22.7942 10.5V19.5L15 24L7.20577 19.5V10.5L15 6Z"
          stroke={color1}
          strokeWidth="2"
        />
        <path d="M11 13.5L15 11.5L19 13.5" stroke={color2} strokeWidth="2" />
        <path d="M11 17.5L15 15.5L19 17.5" stroke={color2} strokeWidth="2" />
      </svg>
    )
  },
)

export const BattleIcon = React.memo(
  ({ color1 = '#514F63', color2 = '#8E8CA0' }: { color1?: string; color2?: string }) => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 25L15.5 21L18.2159 20.612C18.7196 20.5401 19.1769 20.2788 19.4948 19.8815L21 18"
          stroke={color1}
          strokeWidth="2"
        />
        <path
          d="M13.8189 6.73705C14.3752 6.02499 15.4034 5.89874 16.1155 6.45506V6.45506C16.8275 7.01138 16.9538 8.03961 16.3975 8.75167L15.4721 9.93601L12.8936 7.92139L13.8189 6.73705Z"
          stroke={color1}
          strokeWidth="2"
        />
        <path
          d="M16.8794 8.135C17.4357 7.42294 18.464 7.29669 19.176 7.85301V7.85301C19.8881 8.40933 20.0143 9.43756 19.458 10.1496L18.3715 11.5402C18.0824 11.9103 17.5481 11.9759 17.1781 11.6868L15.9395 10.719C15.5695 10.43 15.5038 9.89564 15.7929 9.52562L16.8794 8.135Z"
          stroke={color1}
          strokeWidth="2"
        />
        <rect
          x="20.3555"
          y="9.00244"
          width="3.27228"
          height="7.17487"
          rx="1.63614"
          transform="rotate(38 20.3555 9.00244)"
          stroke={color1}
          strokeWidth="2"
        />
        <rect
          x="22.2559"
          y="11.8843"
          width="3.27228"
          height="5.65789"
          rx="1.63614"
          transform="rotate(38 22.2559 11.8843)"
          stroke={color1}
          strokeWidth="2"
        />
        <path
          d="M7 21.5L10 17L8.70906 11.4059C8.5765 10.8315 8.70412 10.2278 9.05784 9.75621L10.1756 8.26581C10.885 7.31999 12.2556 7.19261 13.1271 7.9915L16.3165 10.9151C16.9616 11.5065 16.9836 12.5164 16.3647 13.1353V13.1353C15.8586 13.6414 15.07 13.7313 14.463 13.3519L11.5 11.5"
          stroke={color2}
          strokeWidth="2"
        />
      </svg>
    )
  },
)

export const SettingIcon = React.memo(({ size = 24 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1C12.5082 1 13.0081 1.03679 13.498 1.10352L14.2725 3.28906C15.0814 3.49951 15.8452 3.82134 16.5488 4.23438L18.6445 3.23535C19.4437 3.84213 20.1568 4.55542 20.7637 5.35449L19.7637 7.44922C20.1771 8.15305 20.4983 8.91723 20.709 9.72656L22.8955 10.501C22.9623 10.9913 23 11.4914 23 12C23 12.5083 22.9622 13.0081 22.8955 13.498L20.71 14.2725C20.4995 15.0815 20.1778 15.8452 19.7646 16.5488L20.7637 18.6445C20.1568 19.4437 19.4437 20.1568 18.6445 20.7637L16.5488 19.7646C15.8452 20.1778 15.0815 20.4995 14.2725 20.71L13.498 22.8955C13.0081 22.9622 12.5083 23 12 23C11.4914 23 10.9913 22.9623 10.501 22.8955L9.72656 20.709C8.91723 20.4983 8.15305 20.1771 7.44922 19.7637L5.35449 20.7637C4.55542 20.1568 3.84213 19.4437 3.23535 18.6445L4.23438 16.5488C3.82134 15.8452 3.49951 15.0814 3.28906 14.2725L1.10352 13.498C1.03679 13.0081 1 12.5082 1 12C1 11.4914 1.0367 10.9912 1.10352 10.501L3.29004 9.72656C3.50056 8.91775 3.82133 8.15366 4.23438 7.4502L3.23535 5.35449C3.84215 4.55543 4.55543 3.84215 5.35449 3.23535L7.4502 4.23438C8.15366 3.82133 8.91775 3.50056 9.72656 3.29004L10.501 1.10352C10.9912 1.0367 11.4914 1 12 1ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
        fill="currentColor"
      />
    </svg>
  )
})

export const ExitIcon = React.memo(({ size = 24 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8V5C16 4.44772 15.5523 4 15 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H15C15.5523 20 16 19.5523 16 19V16"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M23.4141 12L19.707 15.707L18.293 14.293L19.5859 13H7V11H19.5859L18.293 9.70703L19.707 8.29297L23.4141 12Z"
        fill="currentColor"
      />
    </svg>
  )
})

export const EventIcon = React.memo(
  ({ size = 24, color1 = '#fff' }: { size?: number; color1?: string }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.3403 7.5527C21.214 7.4613 22.8085 7.89063 23.9284 8.33722C24.4896 8.56105 24.938 8.79179 25.2502 8.96944C25.4064 9.05829 25.5301 9.13415 25.6168 9.18999C25.6597 9.21765 25.694 9.24086 25.7189 9.25779C25.7312 9.26618 25.7418 9.27374 25.7496 9.27916C25.7533 9.28175 25.7572 9.28411 25.7599 9.28596C25.761 9.28675 25.7623 9.28813 25.7632 9.28886L25.765 9.28937L25.7648 9.29031C25.7613 9.29582 25.7167 9.35931 25.1847 10.1044L25.7657 9.29056L26.3301 9.69352L23.4277 20.5253L22.255 19.6874C22.253 19.686 22.249 19.6835 22.2447 19.6806C22.2328 19.6724 22.2118 19.6591 22.1836 19.6409C22.1254 19.6034 22.033 19.5463 21.9111 19.4769C21.6662 19.3376 21.3008 19.1486 20.8374 18.9638C19.9069 18.5927 18.6031 18.2452 17.0884 18.3191C15.2147 18.4105 13.6202 17.9812 12.5003 17.5346C12.2732 17.444 12.0655 17.3503 11.8769 17.2614L10.2768 23.2334L8.34491 22.7157L12.486 7.26092L12.4879 7.26143L13.001 5.34655L14.1737 6.18448C14.1756 6.18581 14.1796 6.18833 14.184 6.19129C14.1959 6.19935 14.2168 6.21266 14.2452 6.23093C14.3032 6.26835 14.3956 6.3255 14.5177 6.39493C14.7624 6.53419 15.1279 6.72324 15.5914 6.90809C16.5218 7.27913 17.8256 7.6265 19.3403 7.5527ZM23.187 10.195C22.2564 9.82393 20.9527 9.47645 19.438 9.55034C17.5643 9.64167 15.9698 9.21244 14.8499 8.76582C14.6236 8.67555 14.4164 8.58166 14.2284 8.49313L12.4063 15.2933C12.6291 15.4098 12.9104 15.5447 13.2418 15.6769C14.1722 16.0479 15.476 16.3953 16.9907 16.3215C18.8644 16.2301 20.4589 16.6594 21.5788 17.106C21.805 17.1963 22.0126 17.2893 22.2006 17.3778L24.0226 10.5776C23.7999 10.4611 23.5182 10.3271 23.187 10.195Z"
          fill="currentColor"
        />
        <path
          d="M8.82626 6.82224C8.82825 6.82361 8.83213 6.82603 8.83656 6.82905C8.8485 6.83715 8.86927 6.85035 8.89772 6.86869C8.95587 6.90615 9.04809 6.9632 9.17023 7.03269C9.41506 7.17198 9.78035 7.36096 10.2439 7.54585C10.5516 7.66855 10.901 7.7852 11.2845 7.88836L10.7668 9.82021C10.2983 9.69428 9.87383 9.55167 9.50249 9.40358C9.27605 9.31327 9.0691 9.21947 8.88099 9.13089L7.05889 15.931C7.2817 16.0476 7.56284 16.1824 7.89433 16.3146C8.20203 16.4373 8.55146 16.554 8.93489 16.6572L8.41725 18.589C7.94871 18.4631 7.52424 18.3205 7.1529 18.1724C6.92646 18.0821 6.7195 17.9883 6.5314 17.8997L4.93147 23.8707L2.99962 23.3531L7.65356 5.98431L8.82626 6.82224Z"
          fill={color1}
        />
      </svg>
    )
  },
)

export const RushBIcon = React.memo(
  ({ size = 24, color1 = '#BEBDCE' }: { size?: number; color1?: string }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 8H21L24 13L15 24L6 13L9 8Z"
          stroke={color1}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M6 13L24 13"
          stroke="currentColor"
          strokeWidth="2"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 13L13 8H17L19 13L15 24L11 13Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
